import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "qr_admin_token";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

const qp = (qr) => ({ params: { qr: qr || "main" } });

// Public (per QR)
export const getConfig = (qr) => api.get("/config", qp(qr)).then((r) => r.data);
export const getVideo = (qr) => api.get("/video", qp(qr)).then((r) => r.data);
export const getContact = (qr) => api.get("/contact", qp(qr)).then((r) => r.data);
export const qrDownloadUrl = (qr) => `${API}/qr/download?qr=${encodeURIComponent(qr || "main")}`;
export const trackScan = (qr) => api.post("/track/scan", null, qp(qr)).catch(() => {});
export const trackPlay = (qr) => api.post("/track/play", null, qp(qr)).catch(() => {});
export const trackAmen = (qr) => api.post("/track/amen", null, qp(qr)).then((r) => r.data);

// Auth
export const login = (password) => api.post("/auth/login", { password }).then((r) => r.data);
export const getMe = () => api.get("/auth/me").then((r) => r.data);
export const changePassword = (current_password, new_password) =>
  api.post("/auth/change-password", { current_password, new_password }).then((r) => r.data);

// QR codes management
export const listQrcodes = () => api.get("/qrcodes").then((r) => r.data);
export const createQrcode = (name) => api.post("/qrcodes", { name }).then((r) => r.data);
export const deleteQrcode = (id) => api.delete(`/qrcodes/${id}`).then((r) => r.data);

// Admin (per QR)
export const publishVideo = (payload, qr) => api.post("/video", payload, qp(qr)).then((r) => r.data);
export const unpublishVideo = (qr) => api.delete("/video", qp(qr)).then((r) => r.data);
export const saveContact = (payload, qr) => api.post("/contact", payload, qp(qr)).then((r) => r.data);
export const clearContact = (qr) => api.delete("/contact", qp(qr)).then((r) => r.data);
export const getStats = (qr) => api.get("/stats", qp(qr)).then((r) => r.data);
export const getDailyStats = (qr) => api.get("/stats/daily", qp(qr)).then((r) => r.data);
export const getHourlyStats = (qr) => api.get("/stats/hourly", qp(qr)).then((r) => r.data);
export const getAmenStats = (qr) => api.get("/stats/amen", qp(qr)).then((r) => r.data);
export const uploadVideo = (formData, onProgress, qr) =>
  api
    .post("/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      params: { qr: qr || "main" },
      onUploadProgress: (e) => {
        if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
      },
    })
    .then((r) => r.data);

// Chunked upload for large files (bypasses the ingress request-body limit; multi-replica safe).
export const uploadVideoChunked = async (file, meta, onProgress, qr) => {
  const CHUNK = 5 * 1024 * 1024; // 5 MB per request
  const { upload_id } = await api
    .post("/upload/init", {
      filename: file.name,
      content_type: file.type || "",
      media_type: meta.media_type,
      title: meta.title || "",
      cover_url: meta.cover_url || "",
      total_size: file.size,
    }, { params: { qr: qr || "main" } })
    .then((r) => r.data);

  let sent = 0;
  let index = 0;
  for (let start = 0; start < file.size; start += CHUNK) {
    const blob = file.slice(start, Math.min(start + CHUNK, file.size));
    await api.post("/upload/chunk", blob, {
      params: { qr: qr || "main", upload_id, index },
      headers: { "Content-Type": "application/octet-stream" },
    });
    sent += blob.size;
    index += 1;
    if (onProgress && file.size) onProgress(Math.round((sent / file.size) * 100));
  }

  return api
    .post("/upload/complete", null, { params: { qr: qr || "main", upload_id } })
    .then((r) => r.data);
};
export const uploadCover = (formData, qr) =>
  api
    .post("/upload-cover", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      params: { qr: qr || "main" },
    })
    .then((r) => r.data);
